module.exports = __webpack_public_path__ + "img/transactions.5708796a.svg";